import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { TopImage, Button } from '@project/components/atoms';
import { LoadingContainer } from '@project/components/templates';
import { useGetShowcaseCategory } from '@project/queries';
import { map } from 'lodash';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const CategoryBlocks = ({
  src,
  title,
  onClick,
}: {
  src: string;
  title: string;
  onClick?: () => void;
}) => {
  return (
    <div className="mx-4 cursor-pointer sm:mx-auto lg:mx-0 lg:ml-10">
      <div className="mb-10 flex max-w-[400px] flex-col" onClick={onClick}>
        <div>
          <img className="sm:w-[400px]" src={src} />
        </div>
        <div>
          <p className={`bg-white text-center text-lg text-black shadow-md shadow-gray-400`}>
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};

export const ShowShowcaseCategoryPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: category, isLoading } = useGetShowcaseCategory(id);

  const goBack = () => navigate(-1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mb-20">
      <TopImage />
      <LoadingContainer isLoading={isLoading}>
        <div className="flex flex-col">
          <div className="mt-20 mb-14 md:mx-10 lg:my-16">
            <div className="flex flex-row items-center">
              <Button style="bg-gray-200 rounded md:ml-2 ml-4" onClick={goBack}>
                <ChevronLeftIcon className="w-8" />
              </Button>
              <div className="ml-6 text-4xl font-medium underline decoration-gold decoration-2 underline-offset-4">
                {category?.name}
              </div>
            </div>
          </div>
          <div className="flex flex-row flex-wrap lg:ml-10 xl:ml-16">
            {map(category?.showcases, (item) => (
              <CategoryBlocks
                src={item?.featureImage}
                title={item?.name}
                key={`${item?.id}_${category?.id}`}
                onClick={() => navigate(`/showcase/${item?.id}`)}
              />
            ))}
          </div>
        </div>
      </LoadingContainer>
    </div>
  );
};
